import * as React from "react";
import NextImage from "next/image";
import { Stack, Text, Box } from "@chakra-ui/react";

import { EOfferStatus } from "utils/offer";
import Button from "components/Chakra/Button";
import useRouter from "hooks/useRouter";
import { useContactModal } from "modals/useContactModal";
import { useDetailState } from "scenes/OfferDetail";
import { setSessionRedirectPage } from "helpers/sessions";
import PhoneNumberSwitch from "components/PhoneNumberSwitch";
import FormIN from "./FormIN";
import IconLogoIdealninajemce from "components/Chakra/Icons/LogoIdealninajemce";

interface IProps {
  myOwn: boolean;
}

const ContactBox: React.FC<IProps> = ({ myOwn }) => {
  const { offer, status } = useDetailState();
  const { openModal: openContactModal } = useContactModal();
  const { navigateTo } = useRouter();

  if (!offer) {
    return null;
  }

  return (
    <Box mb="58px">
      <Box
        borderBottomColor="ud-grey-150"
        borderBottomWidth={{
          base: undefined,
          md: offer?.owner?.phone ? "1px" : undefined,
          xl: offer?.owner?.phone ? "1px" : undefined,
        }}
        pb={3}
        data-test="offerDetail.contactIN.header"
      >
        <Stack direction="row">
          {offer?.owner?.photo && (
            <Stack display={["none", "none", "block"]}>
              <NextImage
                src={offer.owner.photo}
                alt=""
                height="44"
                width="44"
                style={{ objectFit: "contain" }}
                data-test="offerDetail.contactIN.owner"
              />
            </Stack>
          )}

          <Box>
            <Text data-test="offerDetail.contactIN.catchLine">
              Bezstarostné bydlení se službou
            </Text>
            <IconLogoIdealninajemce
              h="30px"
              w="auto"
              fill="ud-primary"
              data-test="offerDetail.contactIN.logo"
            />
          </Box>
        </Stack>
        {offer?.owner?.phone && (
          <Stack
            justifyContent="space-between"
            direction="row"
            data-test="offerDetail.contactIN.phone"
          >
            <PhoneNumberSwitch phoneNumber={offer.owner.phone} />
          </Stack>
        )}
      </Box>
      {offer && status === EOfferStatus.ACTIVE ? (
        <>
          <Stack display={{ base: "none", md: "block" }}>
            <FormIN offerId={offer.id} />
          </Stack>
          <Stack
            display={{
              base: "block",
              md: "none",
            }}
          >
            <Button
              w="100%"
              isDisabled={!!myOwn}
              trackEventPayload={{
                "dl.eCat": "Kontaktovat",
                "dl.eAct": "click",
                "dl.eLab": "detail_inzeratu_click",
              }}
              onClick={(e) => {
                setSessionRedirectPage(
                  `${document.location.origin}/inzerat/${
                    offer.seo
                  }/${offer?.id?.toString()}`,
                );
                e.preventDefault();
                e.stopPropagation();
                offer.isContacted
                  ? navigateTo("/moje-schranka/[[...messages]]", {
                      offerId: offer?.id?.toString(),
                    })
                  : openContactModal({
                      offerId: offer.id,
                      isSuspicious: offer.showScamWarning,
                      loginEvent: {
                        LOGIN: {
                          "dl.eAct": "login",
                          "dl.eLab": "Odeslání zprávy – detail inzerátu",
                          "dl.eCat": "",
                        },
                        REGISTRATION: {
                          "dl.eAct": "registration",
                          "dl.eLab": "Odeslání zprávy – detail inzerátu",
                          "dl.eCat": "",
                        },
                      },
                    });
              }}
              data-test="offerDetail.contactIN.button"
            >
              Kontaktovat
            </Button>
          </Stack>
        </>
      ) : (
        <Stack direction="row" justify="center" alignItems="center" pt="20px">
          <Button variant="gray">Inzerát není aktuální</Button>
        </Stack>
      )}
    </Box>
  );
};

export default ContactBox;
